import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { GET_EVENTS } from "pages/group/events/queries";
import type { IEventAttr, IEventData } from "pages/group/events/types";
import { formatEvents } from "pages/group/events/utils";
import { Logger } from "utils/logger";

const useEventsQuery = (groupName: string): { eventsData: IEventData[] } => {
  const { data } = useQuery(GET_EVENTS, {
    onError: ({ graphQLErrors }): void => {
      graphQLErrors.forEach((error): void => {
        Logger.error("Couldn't load group events", error);
      });
    },
    variables: { groupName },
  });

  const eventsData = useMemo(
    (): IEventData[] =>
      formatEvents(
        data?.group.eventsConnection.edges.map(
          (edge): IEventAttr => edge.node,
        ) ?? [],
      ),
    [data],
  );

  return { eventsData };
};

export { useEventsQuery };
